const BASE_WIDTH = 793;
const BASE_HEIGHT = 1122;


const media = {
    margin: 30,    // 间距
    pWidth: 793,   // pc端宽度
    pHeight: 1122, // pc端高度
    mWidth: 325,   // 手机端宽度
    mHeight: 460,  // 手机端高度
    standard: 992  // 判断标准: window.width >992 ? pc端宽度 : 手机端宽度
}

function getWH() {
    let clientWidth = (document.documentElement||document.body).clientWidth; // 网页可见区域宽
    let clientHeight = (document.documentElement||document.body).clientHeight; // 网页可见区域高
    let width = clientWidth;
    let height = clientHeight;

    if(clientWidth >= media.standard ) {
        // 大屏
        width = media.pWidth;
        height = media.pHeight;
    } else {
        // 小屏
        width = clientWidth - media.margin * 2 - 2;  // 宽度 - margin * 2 - border * 2
        height = clientHeight - media.margin * 2 - 2; // 高度 - margin * 2 - border * 2
    }

    console.log('getWH = ', width, height);
    return {
        width,
        height,
        clientWidth,
        clientHeight
    };
}


export {
    media,
    getWH
};